import { render } from "./packing_list_check.vue?vue&type=template&id=bb6dd4a0&scoped=true"
import script from "./packing_list_check.vue?vue&type=script&lang=js"
export * from "./packing_list_check.vue?vue&type=script&lang=js"

import "./packing_list_check.vue?vue&type=style&index=0&id=bb6dd4a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6dd4a0"]])

export default __exports__